<template>
    <div class="carban-check">
        <div class="search_wrap">
            <el-form
                class="leader-style-form leader-form-inner-tab-inline"
                :inline="true"
                :model="searchForm"
            >
                <el-form-item label="时间" style="float: left">
                    <el-date-picker
                        v-model="searchForm.time"
                        type="month"
                        placeholder="选择日期"
                        value-format="yyyy-MM"
                        format="yyyy-MM"
                        :picker-options="pickerOptions"
                        :clearable="false"
                        :editable="false"
                    ></el-date-picker>
                    <el-button
                        type="primary"
                        size="small"
                        style="margin-left: 40px"
                        @click="search"
                        >查询</el-button
                    >
                </el-form-item>
            </el-form>
        </div>
        <div class="echarts_box">
            <div class="box1">
                <div class="box-title">外购电力间接碳排放量</div>
                <div class="carban_echarts_bar">
                    <v-chart
                        :auto-resize="true"
                        :options="carbanBar"
                        ref="carbanBar"
                        theme="ovilia-green"
                        @click="consumpClick"
                    />
                </div>
            </div>
            <div class="box2">
                <div class="box-title2">碳排放构成</div>
                <div class="carban_echarts_pie">
                    <div class="pie_left">
                        <v-chart
                            :auto-resize="true"
                            :options="carbanPie"
                            ref="carbanPie"
                            @click="pieClick"
                            @legendselectchanged="legendSelect"
                        />
                    </div>
                    <div class="pie_right">
                        <div class="pie_data">
                            <div class="pie_data_data">{{ selectPieData }}</div>
                            <div class="pie_data_text">{{ selectPieText }}</div>
                            <div class="pie_data_text">（吨）</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import "echarts/lib/chart/bar";
import "echarts/lib/chart/line";
import "echarts/lib/chart/pie";
import "echarts/lib/chart/bar";
import "echarts/lib/chart/treemap";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/title";
import "echarts/lib/component/legend";
import 'echarts/lib/component/legendScroll';
import "echarts/lib/component/toolbox";
import "echarts/lib/component/markPoint";
import "echarts/lib/component/graphic";
import * as api from "@/http/api.js";
import echarts from "echarts";
export default {
    data() {
        return {
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                }
            },
            searchForm: {
                time: ""
            },
            x_list: [],
            y_list: [],
            selectMonth: "",
            treeMaps: [],
            selectPieData: "",
            selectPieText: ""
        };
    },
    created() {
        this.getSysDate();
    },
    methods: {
        search() {
            this.getEnergyList(this.searchForm.time);
        },
        getSysDate() {
            api.getSysDate1().then(res => {
                if (res && res.error_code === "0") {
                    this.searchForm.time = res.bus_json.sysdate3;
                    this.selectMonth = this.searchForm.time;
                    this.getEnergyList(this.searchForm.time);
                    this.getAmountByMonth(this.selectMonth);
                }
            });
        },
        getEnergyList(time) {
            api.getEnergyList({ show_time: time }).then(res => {
                if (res && res.error_code === "0") {
                    this.x_list = res.bus_json.months;
                    this.y_list = res.bus_json.amountList;
                }
            });
        },
        getAmountByMonth(month) {
            api.getAmountByMonth({ show_time: month }).then(res => {
                if (res && res.error_code === "0") {
                    this.treeMaps = res.bus_json;
                    if (this.treeMaps.length > 0) {
                        this.selectPieData = this.treeMaps[0].value;
                        this.selectPieText = this.treeMaps[0].name;
                    }
                }
            });
        },
        consumpClick(params) {
            this.selectMonth = params.name;
            this.$nextTick(() => {
                const carbanBar = this.$refs.carbanBar.chart;
                //使点击区域变成pointer
                carbanBar.getZr().on("mousemove", function(params) {
                    var pointInPixel = [params.offsetX, params.offsetY];
                    if (dayDemandBar.containPixel("grid", pointInPixel)) {
                        dayDemandBar.getZr().setCursorStyle("pointer");
                    }
                });
                //折线图区域点击事件
                carbanBar.getZr().on("click", params => {
                    var pointInPixel = [params.offsetX, params.offsetY];
                    var pointInGrid = carbanBar.convertFromPixel(
                        "grid",
                        pointInPixel
                    );
                    var category = carbanBar.getModel().get("xAxis")[0].data[
                        pointInGrid[0]
                    ];
                    if (undefined != category) {
                        this.selectMonth = category;
                        // this.getHourFactorData(category);
                        this.getAmountByMonth(category);
                    }
                });
            });
        },
        pieClick(params) {
            this.selectPieData = params.data.value;
            this.selectPieText = params.data.name;
        },
        legendSelect(params) {
            this.treeMaps.forEach(item => {
                if (item.name == params.name) {
                    this.selectPieData = item.value;
                    this.selectPieText = item.name;
                }
            });
        }
    },
    computed: {
        carbanBar() {
            const option = {
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        // 坐标轴指示器，坐标轴触发有效
                        type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
                    },
                    formatter: function(params) {
                        var tar = params[0];
                        // return "综合能耗:"+tar.data.value+"元";
                        return (
                            tar.axisValue +
                            "<br/>" +
                            "碳排放：" +
                            tar.data +
                            "吨"
                        );
                    }
                },
                // legend: {
                //     data: ["综合能耗"],
                //     textStyle: { fontSize: 12, color: "#fff" }
                // },
                grid: {
                    left: "2%",
                    right: "2%",
                    bottom: "2%",
                    containLabel: true
                },
                xAxis: [
                    {
                        type: "category",
                        axisLabel: {
                            fontSize: 14,
                            //y轴文字的配置
                            textStyle: {
                                color: "#999999" //颜色
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#0c576d" // 颜色
                            }
                        },
                        xAxisLeft: "#666",
                        // data: this.x_list
                        data: this.x_list
                    }
                ],
                yAxis: [
                    {
                        name: "吨",
                        type: "value",
                        yAxisTop: "yellow",
                        nameTextStyle: {
                            color: "white",
                            padding: 10,
                            fontSize: 14
                        },
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: "#999999" //颜色
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#0c576d" // 颜色
                            }
                        },
                        splitLine: {
                            lineStyle: {
                                color: "#0c576d" // 颜色
                            }
                        },
                        xAxisLeft: "#666666"
                    }
                ],
                series: [
                    {
                        name: "碳排放",
                        type: "bar",
                        itemStyle: {
                            normal: {
                                // color: "#409eff" // 柱子颜色
                                label: {
                                    show: true,
                                    position: "top",
                                    textStyle: {
                                        color: "#fff",
                                        fontSize: 14
                                    }
                                },
                                color: new echarts.graphic.LinearGradient(
                                    0,
                                    0,
                                    0,
                                    1,
                                    [
                                        {
                                            offset: 0,
                                            color: "#0a2d4e"
                                        },
                                        {
                                            offset: 1,
                                            color: "#602038"
                                        }
                                    ]
                                )
                            }
                        },
                        barWidth: 40,
                        data: this.y_list
                    }
                ]
            };
            return option;
        },
        carbanPie() {
            const option = {
                title: {
                    text: `${this.selectMonth}月碳排放构成`,
                    top: "2%",
                    left: "2%",
                    textStyle: {
                        color: "#56fcff"
                    }
                },
                legend: {
                  //  type: 'scroll',
                    orient: "vertical",
                    x: "left",
                    top: "8%",
                    itemHeight: 10,
                    itemWidth: 12,
                 //   bottom: "60%",
                    textStyle: {
                        color: "#fff",
                        fontSize: 12
                    }
                },
                graphic: {
                    // 添加原生图形元素组件
                    elements: [
                        {
                            type: "text", // 组件类型
                            left: "center", //定位
                            top: "68%", // 定位
                            style: {
                                // 样式
                                text: this.selectPieData, //文字
                                fontSize: 26, //文字大小
                                textAlign: "center", //定位
                                fill: "#83fcfc" // 字体颜色
                            }
                        },
                        {
                            type: "text",
                            left: "center",
                            top: "80%",
                            style: {
                                text: this.selectPieText,
                                fontSize: 12,
                                textAlign: "center",
                                width: 20,
                                height: 50,
                                fill: "#fff"
                            }
                        }
                    ]
                },
                series: [
                    {
                        name: "",
                        type: "pie",
                        label: {
                            show: false
                        },
                        radius: ["50%", "65%"],
                        center: ["50%", "75%"],
                        itemStyle: {
                            color: function(colors) {
                                var colorList = [
                                    "#3b73b7",
                                    "#38cafb",
                                    "#5f608a",
                                    "#45cebb",
                                    "#4fa99c",
                                    "#6d8bb6",
                                    "#358277",
                                    "#33507a",
                                    "#1f55a9"
                                ];
                                return colorList[colors.dataIndex];
                            }
                        },
                        data: this.treeMaps
                    }
                ]
            };
            return option;
        }
    }
};
</script>
<style lang="scss">
.carban-check {
    padding: 0 20px 10px 40px;
    // background: transparent;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    overflow: auto;
    .search_wrap {
        width: 100%;
    }
    .echarts_box {
        width: 100%;
        height: 30rem;
        margin-top: 2rem;
        display: flex;
        justify-content: space-between;
        .box-title {
            color: #fff;
            font-size: 0.9rem;
            margin-top: 0.8rem;
            margin-left: 2.5rem;
            margin-bottom: 1rem;
        }
        .box-title2 {
            color: #fff;
            font-size: 0.9rem;
            margin-top: 1.1rem;
            margin-left: 2.8rem;
            margin-bottom: 1.1rem;
        }
        .box1 {
            width: 65%;
            height: 100%;
            background: url("../../../../assets/image/custom/left.png")
                no-repeat;
            background-size: 100% 100%;
            .carban_echarts_bar {
                width: 100%;
                height: 26rem;
                .echarts {
                    width: 100%;
                    height: 100%;
                }
            }
        }
        .box2 {
            width: 33%;
            height: 100%;
            background: url("../../../../assets/image/custom/right.png")
                no-repeat;
            background-size: 100% 100%;
            .carban_echarts_pie {
                width: 93%;
                height: 26rem;
                display: flex;
                .pie_left {
                    width: 50%;
                    height: 100%;
                    .echarts {
                        width: 100%;
                        height: 100%;
                    }
                }
                .pie_right {
                    width: 50%;
                    height: 100%;
                    display: flex;
                    align-items: center;

                    .pie_data {
                        margin-left: 12.5%;
                        width: 75%;
                        height: 55%;
                        background: url("../../../../assets/image/custom/pie_data.png")
                            no-repeat;
                        background-size: 100% 100%;
                        text-align: center;
                        .pie_data_data {
                            color: #56fcff;
                            font-size: 2rem;
                        }
                        .pie_data_text {
                            color: #fff;
                            font-size: 1rem;
                            margin-top: 0.5rem;
                        }
                    }
                }
            }
        }
    }
}
</style>
